export function fmtMoney(n: number | null | undefined, devise = "EUR"): string {
  if (n === null || n === undefined) return "—";
  const s = n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return s + (devise === "TND" ? " TND" : " €");
}

export function fmtMoney0(n: number | null | undefined, devise = "EUR"): string {
  if (n === null || n === undefined) return "—";
  return n.toLocaleString("fr-FR", { maximumFractionDigits: 0 }) + (devise === "TND" ? " TND" : " €");
}

export function fmtDate(s: string | null | undefined): string {
  if (!s) return "—";
  const p = s.slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
}

export function fmtDateTime(s: string | null | undefined): string {
  if (!s) return "—";
  const d = new Date(s);
  return d.toLocaleDateString("fr-FR") + " " + d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}

export function fmtPct(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  return n.toLocaleString("fr-FR", { maximumFractionDigits: 1 }) + " %";
}

export const DEVIS_STATUTS: { key: string; label: string; prob: number; color: string }[] = [
  { key: "brouillon", label: "Brouillon", prob: 10, color: "bg-gray-100 text-gray-700" },
  { key: "envoye", label: "Envoyé", prob: 30, color: "bg-blue-50 text-info" },
  { key: "negociation", label: "En négociation", prob: 60, color: "bg-amber-50 text-amber" },
  { key: "accepte", label: "Accepté", prob: 80, color: "bg-lime-soft text-green" },
  { key: "gagne_attente", label: "Gagné (en attente)", prob: 100, color: "bg-lime/40 text-green-deep" },
  { key: "gagne", label: "Gagné (clôturé)", prob: 100, color: "bg-green text-white" },
  { key: "reporte", label: "Reporté", prob: 20, color: "bg-gray-100 text-muted" },
  { key: "perdu", label: "Perdu", prob: 0, color: "bg-red-50 text-danger" },
];

export function statutLabel(key: string): string {
  return DEVIS_STATUTS.find((s) => s.key === key)?.label || key;
}

export function statutColor(key: string): string {
  return DEVIS_STATUTS.find((s) => s.key === key)?.color || "bg-gray-100 text-gray-700";
}

const STATUTS_CLOS = ["gagne", "gagne_attente", "perdu"];

export const STATUTS_PARKES = ["perdu", "reporte"];

export function todayISO(): string {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
}

export function clotureDepassee(d: { statut?: string; date_cloture_estimee?: string | null }): boolean {
  if (!d.date_cloture_estimee || STATUTS_CLOS.includes(d.statut || "")) return false;
  return d.date_cloture_estimee.slice(0, 10) < todayISO();
}
